import { TransactionStatus } from '../service-proxies';


export class SettingDto implements ISettingDto {
    id!: number;
    allowLongLatDist!: number;
    applicationLimitDays!: number;
    salaryCalcType!: number;
    salaryCalcDay!: number;
    showProjectInThumbApplication!: boolean;
    thumbApplicationDefaultStatus!: TransactionStatus;
    thumbApplicationDefaultStatusName!: string | undefined;
    isSandwichLeaveApplicable!: boolean;
    incrementWaiveDays!: number;
    isLeadersCanApproveApplication!: boolean;
    isEnableCrossCompanyEmployeeListing!: boolean;
    isAvoidLeaveCalcOnHolidays!: boolean;
    isCalcOTAccordingToAttendance!: boolean;
    androidAppLink!: string | undefined;
    iosAppLink!: string | undefined;
    otApplicationLimitDays!: number;
    isLockApproverSelection!: boolean;
    salarySlipType!: number;
    logoUri!: string | undefined;
    logoType!: string | undefined;
    logoPath!: string | undefined;
    customEmailAddress!: string | undefined;
    customEmailPassword!: string | undefined;
    customEmailSenderName!: string | undefined;
    customEmailSMTPHostName!: string | undefined;
    customEmailSMTPHostPort!: number;

    constructor(data?: ISettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allowLongLatDist = _data["allowLongLatDist"];
            this.applicationLimitDays = _data["applicationLimitDays"];
            this.salaryCalcType = _data["salaryCalcType"];
            this.salaryCalcDay = _data["salaryCalcDay"];
            this.showProjectInThumbApplication = _data["showProjectInThumbApplication"];
            this.thumbApplicationDefaultStatus = _data["thumbApplicationDefaultStatus"];
            this.thumbApplicationDefaultStatusName = _data["thumbApplicationDefaultStatusName"];
            this.isSandwichLeaveApplicable = _data["isSandwichLeaveApplicable"];
            this.incrementWaiveDays = _data["incrementWaiveDays"];
            this.isLeadersCanApproveApplication = _data["isLeadersCanApproveApplication"];
            this.isEnableCrossCompanyEmployeeListing = _data["isEnableCrossCompanyEmployeeListing"];
            this.isAvoidLeaveCalcOnHolidays = _data["isAvoidLeaveCalcOnHolidays"];
            this.isCalcOTAccordingToAttendance = _data["isCalcOTAccordingToAttendance"];
            this.androidAppLink = _data["androidAppLink"];
            this.iosAppLink = _data["iosAppLink"];
            this.otApplicationLimitDays = _data["otApplicationLimitDays"];
            this.isLockApproverSelection = _data["isLockApproverSelection"];
            this.salarySlipType = _data["salarySlipType"];
            this.logoUri = _data["logoUri"];
            this.logoType = _data["logoType"];
            this.logoPath = _data["logoPath"];
            this.customEmailAddress = _data["customEmailAddress"];
            this.customEmailPassword = _data["customEmailPassword"];
            this.customEmailSenderName = _data["customEmailSenderName"];
            this.customEmailSMTPHostName = _data["customEmailSMTPHostName"];
            this.customEmailSMTPHostPort = _data["customEmailSMTPHostPort"];
        }
    }

    static fromJS(data: any): SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allowLongLatDist"] = this.allowLongLatDist;
        data["applicationLimitDays"] = this.applicationLimitDays;
        data["salaryCalcType"] = this.salaryCalcType;
        data["salaryCalcDay"] = this.salaryCalcDay;
        data["showProjectInThumbApplication"] = this.showProjectInThumbApplication;
        data["thumbApplicationDefaultStatus"] = this.thumbApplicationDefaultStatus;
        data["thumbApplicationDefaultStatusName"] = this.thumbApplicationDefaultStatusName;
        data["isSandwichLeaveApplicable"] = this.isSandwichLeaveApplicable;
        data["incrementWaiveDays"] = this.incrementWaiveDays;
        data["isLeadersCanApproveApplication"] = this.isLeadersCanApproveApplication;
        data["isEnableCrossCompanyEmployeeListing"] = this.isEnableCrossCompanyEmployeeListing;
        data["isAvoidLeaveCalcOnHolidays"] = this.isAvoidLeaveCalcOnHolidays;
        data["isCalcOTAccordingToAttendance"] = this.isCalcOTAccordingToAttendance;
        data["androidAppLink"] = this.androidAppLink;
        data["iosAppLink"] = this.iosAppLink;
        data["otApplicationLimitDays"] = this.otApplicationLimitDays;
        data["isLockApproverSelection"] = this.isLockApproverSelection;
        data["salarySlipType"] = this.salarySlipType;
        data["logoUri"] = this.logoUri;
        data["logoType"] = this.logoType;
        data["logoPath"] = this.logoPath;
        data["customEmailAddress"] = this.customEmailAddress;
        data["customEmailPassword"] = this.customEmailPassword;
        data["customEmailSenderName"] = this.customEmailSenderName;
        data["customEmailSMTPHostName"] = this.customEmailSMTPHostName;
        data["customEmailSMTPHostPort"] = this.customEmailSMTPHostPort;
        return data; 
    }
}

export interface ISettingDto {
    id: number;
    allowLongLatDist: number;
    applicationLimitDays: number;
    salaryCalcType: number;
    salaryCalcDay: number;
    showProjectInThumbApplication: boolean;
    thumbApplicationDefaultStatus: TransactionStatus;
    thumbApplicationDefaultStatusName: string | undefined;
    isSandwichLeaveApplicable: boolean;
    incrementWaiveDays: number;
    isLeadersCanApproveApplication: boolean;
    isEnableCrossCompanyEmployeeListing: boolean;
    isAvoidLeaveCalcOnHolidays: boolean;
    isCalcOTAccordingToAttendance: boolean;
    androidAppLink: string | undefined;
    iosAppLink: string | undefined;
    otApplicationLimitDays: number;
    isLockApproverSelection: boolean;
    salarySlipType: number;
    logoUri: string | undefined;
    logoType: string | undefined;
    logoPath: string | undefined;
    customEmailAddress: string | undefined;
    customEmailPassword: string | undefined;
    customEmailSenderName: string | undefined;
    customEmailSMTPHostName: string | undefined;
    customEmailSMTPHostPort: number;
}

